import { SourcingInternalSelectedCandidateProfilesTable } from 'modules/sourcing-internal/tables/SourcingInternalSelectedCandidateProfilesTable';

export const SourcingInternalSelectedCandidatesStep: React.FC = () => {
  return <SourcingInternalSelectedCandidateProfilesTable />;
};
